export default "__VITE_ASSET__CMCg7kO___"